import useProject from '@hooks/useProject';
import useScript from '@hooks/useScript';

const kakaoRedirectUri = import.meta.env.VITE_KAKAO_REDIRECT_URI;
const kakaoScriptUrl = import.meta.env.VITE_KAKAO_SCRIPT_URL;

function useSignInWithKakao() {
    const project = useProject();
    const kakaoJsKey = import.meta.env.MODE === 'production'
        ? project?.kakaoJavascriptKey : import.meta.env.VITE_KAKAO_JS_KEY;
    const initKakao = () => {
        // @ts-ignore
        if (!window.Kakao.isInitialized()) {
            // @ts-ignore
            window.Kakao.init(kakaoJsKey!);
        }
    };
    const handleKakaoLogin = () => {
        // @ts-ignore
        window.Kakao.Auth.authorize({
            redirectUri: kakaoRedirectUri,
        });
    };
    useScript({ src: kakaoScriptUrl, onLoad: initKakao, enabled: !!kakaoJsKey });

    return {
        kakaoJsKey, handleKakaoLogin,
    };
}

export default useSignInWithKakao;
